
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import { SortColumn, SortDirection } from "@/hooks/useOrganizationManagement";

interface OrganizationsTableHeaderProps {
  sortColumn: SortColumn;
  sortDirection: SortDirection;
  onSort: (column: SortColumn) => void;
}

export function OrganizationsTableHeader({
  sortColumn,
  sortDirection,
  onSort,
}: OrganizationsTableHeaderProps) {
  const getSortIcon = (column: SortColumn) => {
    if (sortColumn !== column) {
      return <ArrowUpDown className="ml-2 h-4 w-4" />;
    }
    return sortDirection === "asc" ? 
      <ArrowUp className="ml-2 h-4 w-4" /> : 
      <ArrowDown className="ml-2 h-4 w-4" />;
  };

  return (
    <TableHeader>
      <TableRow>
        <TableHead>
          <Button
            variant="ghost"
            onClick={() => onSort("name")}
            className="h-auto p-0 font-semibold text-muted-foreground hover:text-foreground"
          >
            Nome
            {getSortIcon("name")}
          </Button>
        </TableHead>
        <TableHead>
          <Button
            variant="ghost"
            onClick={() => onSort("created_at")}
            className="h-auto p-0 font-semibold text-muted-foreground hover:text-foreground"
          >
            Criado em
            {getSortIcon("created_at")}
          </Button>
        </TableHead>
        <TableHead className="w-[100px]">Ações</TableHead>
      </TableRow>
    </TableHeader>
  );
}
